import { Flex, HStack, IconButton, Text, Spacer, Icon, VStack } from '@chakra-ui/react';

import { IoRemoveCircleOutline, IoStar } from 'react-icons/io5';

type CouponInfoBarProps = {
  value: string;
};

export default function CouponInfoBar({ value }: CouponInfoBarProps) {
  return (
    <VStack align="stretch">
      <Text fontSize="sm" fontWeight="bold">
        已使用優惠券
      </Text>
      <Flex p={2} align="center" bgColor="gray.200" borderRadius="5px">
        <HStack align="flex-start">
          <Icon as={IoStar} boxSize="1.25rem" />
          <Text fontSize="sm">{value}</Text>
        </HStack>
        <Spacer />
      </Flex>
    </VStack>
  );
}
